import { Link } from "react-router-dom";
import "../css/mainnavbar.css";

function MainNavbar() {
  return (
    <nav className="main-navbar">

      <Link to="/">Home</Link>

      <Link to="/shop">Shop</Link>

      <Link to="/shop?category=Whiskey">Whiskey</Link>

      <Link to="/shop?category=Wine">Wine</Link>

      <Link to="/shop?category=Beer">Beer</Link>

      <Link to="/shop?category=Vodka">Vodka</Link>

      <Link to="/shop?category=Rum">Rum</Link>

      <Link to="/shop?category=Tequila">Tequila</Link>

      <Link to="/shop?category=Cigars">Cigars</Link>

      <Link to="/contact">Contact</Link>

    </nav>
  );
}

export default MainNavbar;